<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button class="main-btn" type="submit">
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj mašinu</h3>

    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Naziv</label>
            <input type="text" formControlName="name" pInputText />
          </div>

          <div class="field">
            <label>Kod</label>
            <input type="text" formControlName="code" pInputText />
          </div>

          <div class="field">
            <label>Serijski broj</label>
            <input type="text" formControlName="serial_number" pInputText />
          </div>

          <div class="field">
            <label>Operacije</label>
            <p-multiSelect
              [options]="allOperations"
              defaultLabel="Izaberi operacije"
              formControlName="operations"
              (onChange)="addOperatios($event, 'operations')"
              styleClass="w-100"
              optionValue="id"
              optionLabel="name"
            ></p-multiSelect>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
